module.exports = __webpack_public_path__ + "static/media/banner.8d9d927a.jpg";